import { useState } from 'react';

export default function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const galleryImages = [
    {
      src: 'https://public.readdy.ai/ai/img_res/0c5343df32c44c4e1fa705a7933ffe34.jpg',
      alt: '고흥꿈트리 치유마을 전경',
      category: '마을 풍경'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Traditional%20Korean%20food%20preparation%2C%20healthy%20healing%20cuisine%2C%20organic%20ingredients%2C%20therapeutic%20cooking%2C%20natural%20healing%20meals%2C%20traditional%20Korean%20kitchen&width=600&height=400&seq=gallery-2&orientation=landscape',
      alt: '남도음식 체험',
      category: '음식 체험'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Korean%20yuzu%20citrus%20farm%20with%20golden%20fruits%2C%20organic%20farming%2C%20therapeutic%20agriculture%2C%20peaceful%20orchard%20setting%2C%20healing%20citrus%20garden&width=600&height=400&seq=gallery-3&orientation=landscape',
      alt: '유자농장 체험',
      category: '농장 체험'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Korean%20forest%20therapy%20experience%2C%20healing%20forest%20paths%2C%20natural%20woodland%20meditation%2C%20therapeutic%20trees%2C%20peaceful%20forest%20environment&width=600&height=400&seq=gallery-4&orientation=landscape',
      alt: '숲 치유 프로그램',
      category: '숲 치유'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Purple%20lavender%20field%20in%20Korea%2C%20therapeutic%20lavender%20farm%2C%20aromatic%20healing%20garden%2C%20peaceful%20lavender%20rows%2C%20natural%20aromatherapy&width=600&height=400&seq=gallery-5&orientation=landscape',
      alt: '라벤더 농장',
      category: '아로마 테라피'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Traditional%20Korean%20hanok%20guesthouse%2C%20peaceful%20Korean%20architecture%2C%20healing%20accommodation%2C%20traditional%20house%20with%20garden%2C%20serene%20hanok%20setting&width=600&height=400&seq=gallery-6&orientation=landscape',
      alt: '한옥펜션',
      category: '숙박 시설'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Korean%20healing%20flower%20farm%2C%20therapeutic%20garden%20with%20colorful%20flowers%2C%20horticultural%20therapy%2C%20peaceful%20flower%20fields%2C%20healing%20plants&width=600&height=400&seq=gallery-7&orientation=landscape',
      alt: '원예 치유 프로그램',
      category: '원예 치유'
    },
    {
      src: 'https://readdy.ai/api/search-image?query=Korean%20coffee%20farm%2C%20organic%20coffee%20plants%2C%20coffee%20bean%20cultivation%2C%20therapeutic%20coffee%20experience%2C%20natural%20coffee%20plantation&width=600&height=400&seq=gallery-8&orientation=landscape',
      alt: '커피농장 투어',
      category: '커피 체험'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-gradient-to-b from-white to-green-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-800 mb-6">갤러리</h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            고흥꿈트리 치유마을의 아름다운 순간들을 사진으로 만나보세요
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {galleryImages.map((image, index) => (
            <div 
              key={index} 
              className="relative group cursor-pointer overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
              onClick={() => setSelectedImage(image.src)}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-64 object-cover object-top transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-center text-white">
                  <i className="ri-zoom-in-line text-3xl mb-2"></i>
                  <p className="text-sm font-semibold">{image.category}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal */}
        {selectedImage && (
          <div 
            className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-4xl max-h-full">
              <img
                src={selectedImage}
                alt="확대된 이미지"
                className="max-w-full max-h-full object-contain rounded-lg"
              />
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}